import { useTooltip } from "hooks/useTooltip";

export const Ghost = () => {
    const { tooltipRef } = useTooltip({ title: "Stormy" });

    return (
        <div className="ghost__body" ref={tooltipRef}>
            <div className="ghost__speckles"></div>
            <span className="ghost__eye"></span>
            <span className="ghost__eye"></span>
            <div className="ghost__mouth"></div>
            <div className="ghost__tentacles">
                <span className="tentacle"></span>
                <span className="tentacle"></span>
                <span className="tentacle"></span>
            </div>
        </div>
    );
};
